import { postData } from "../api/fetch";
import AvtoCard from "../components/AvtoCard";
import initModals from "../components/initModal";

export function getCatalog(page = "1") {
  const data = {
    // act: "get_auto_filter",
    act: "",
    marka: "all",
    model: "",
    yearFrom: "",
    yearTo: "",
    mileageFrom: "",
    mileageTo: "",
    priceFrom: "",
    priceTo: "",
    page: page,
    sorted: "CREATE_AT-DESC",
    country: "",
  };

  const pageEl = document.querySelector(".page");
  if (pageEl && pageEl.getAttribute("id") === "catalogue") {
    data.marka = getSelectValueById("make") || "";
    data.model = getSelectValueById("model") || "";
    data.yearFrom = getSelectValueById("year-start") || "";
    data.yearTo = getSelectValueById("year-end") || "";
    data.mileageFrom = getSelectValueById("mileage-start", true) || "";
    data.mileageTo = getSelectValueById("mileage-end", true) || "";
    data.priceFrom = getSelectValueById("price-start", true) || "";
    data.priceTo = getSelectValueById("price-end", true) || "";
    data.country = getSelectValueById("country" || "korea");
  }

  if (document.querySelector("section#catalogue")) {
    data.act = "get_auto_filter";
    getPostData(data, document.querySelector("section#catalogue"));
  }

  if (document.querySelector("section#catalogue-going")) {
    data.act = "get_auto_filtermy";
    getPostData(data, document.querySelector("section#catalogue-going"));
  }

  if (
    !document.querySelector("section#catalogue") &&
    !document.querySelector("section#catalogue-going")
  ) {
    const pageEl = document.querySelector(".page").getAttribute("id");
    if (pageEl === "catalogue") {
      data.act = "get_auto_filter";
      getPostData(data, document.querySelector("#catalogue"));
    } else if (pageEl === "catalogue-going") {
      data.act = "get_auto_filtermy";
      getPostData(data, document.querySelector("#catalogue-going"));
    }
  }
}

function getPostData(data, container) {
  postData(window.api_url, data)
    .then((response) => {
      // console.log(data);
      // console.log("Ответ от сервера:", response);

      const pageEl = document.querySelector(".page");
      if (pageEl) {
        switch (pageEl.getAttribute("id")) {
          case "index":
            for (let i = 0; i < 6; i++) {
              const car = response[i];
              // let description = `${car.year} г.в. | ${numberRu(car.mileage)} км | ${car.engine} см³ | ${car.whatfuel} | ${getCountry(car.country)}`;

              const cardEl = new AvtoCard(
                car.images[0],
                car.make,
                car.model,
                getDescriptionCar(car),
                numberRu(car.price),
                car.id,
                car.carid,
                container,
              );

              const cardListEl = container.querySelector(
                ".catalogue__cards-list",
              );
              if (cardListEl) {
                cardListEl.append(cardEl.getAvtoCard());
              }
            }
            break;
          case "catalogue":
          case "catalogue-going":
            const cardListEl = document.querySelector(".catalogue__cards-list");

            if (Number(data.page) === 1) {
              if (cardListEl) {
                cardListEl.innerHTML = "";
              }
            }

            const count = Math.min(response.length, 12); // максимум 9 или меньше, если элементов меньше
            const loadBtnEl = document.getElementById("more__see");
            if (loadBtnEl) {
              if (count < 12) {
                loadBtnEl.style.display = "none";
              } else {
                loadBtnEl.style.display = "block";
              }
            }

            for (let i = 0; i < count; i++) {
              const car = response[i];
              // let description = `${car.year} | ${numberRu(car.mileage)} км | ${
              //   car.engine
              // } см³ | ${car.whatfuel} | ${getCountry(car.country)}`;

              const cardEl = new AvtoCard(
                car.images[0],
                car.make,
                car.model,
                getDescriptionCar(car),
                numberRu(car.price),
                car.id,
                car.carid,
                container,
              );

              if (cardListEl) {
                cardListEl.append(cardEl.getAvtoCard());
              }
            }

            // Если пришёл пустой массив, можно показать заглушку
            if (response.length === 0) {
              const cardListEl = document.querySelector(
                ".catalogue__cards-list",
              );
              if (cardListEl) {
                const emptyMsg = document.createElement("p");
                emptyMsg.textContent = "Нет доступных автомобилей";
                cardListEl.append(emptyMsg);
              }
            }

            break;
          case "card":
            for (let i = 0; i < 3; i++) {
              const car = response[i];
              // let description = `${car.year} | ${numberRu(car.mileage)} км | ${
              //   car.engine
              // } см³ | ${car.whatfuel} | ${getCountry(car.country)}`;

              const cardEl = new AvtoCard(
                car.images[0],
                car.make,
                car.model,
                getDescriptionCar(car),
                numberRu(car.price),
                car.id,
                car.carid,
                container,
              );
              const cardListEl = document.querySelector(
                ".catalogue__cards-list",
              );
              if (cardListEl) {
                cardListEl.append(cardEl.getAvtoCard());
              }
            }
            break;
        }

        initModals();
      }

      // if (resultCountEl) {
      //   resultCountEl.innerHTML = '';
      // }
      // if (filterResultEl) {
      //   filterResultEl.style.visibility = 'hidden';
      // }

      // if (res.length !== 0) {
      //   createdCards(res);
      //   if (paginationEl && paginationEl.hasAttribute('style')) {
      //     paginationEl.removeAttribute('style');
      //   }

      //   pagination(res[0].count_auto, getCurrentPage()); // общее кол-во элементов
      // } else {
      //   createdCards(res);
      //   if (paginationEl) {
      //     paginationEl.style.display = 'none';
      //   }
      //   if (resultCountEl) {
      //     resultCountEl.innerHTML = '0';
      //   }
      //   if (filterResultEl && filterResultEl.hasAttribute('style')) {
      //     filterResultEl.removeAttribute('style');
      //   }
      // }
    })
    .catch((err) => {
      console.error("Ошибка при POST запросе:", err);
    });
}

function getDescriptionCar(car) {
  let description = [];

  if (car.year && car.year !== 0) {
    description.push(`${car.year} г.в.`);
  }
  if (car.mileage && car.mileage !== 0) {
    description.push(`${numberRu(car.mileage)} км`);
  }
  if (car.engine && car.engine !== 0) {
    description.push(`${car.engine} см³`);
  }
  if (car.whatfuel && car.whatfuel !== "") {
    description.push(car.whatfuel);
  }
  if (car.country && car.country !== 0) {
    description.push(getCountry(car.country));
  }

  return description.join(" | ");
}

// Получение страны на русском языке
export function getCountry(country) {
  switch (country) {
    case "china":
      return "Китай";
      break;
    case "korea":
      return "Корея";
      break;
    case "japan":
      return "Япония";
      break;
  }
}
// Получение числа в русском читаемом виде
export function numberRu(number) {
  return number.toLocaleString("ru-RU");
}
export function getSelectValueById(id, asNumber = false) {
  const el = document.getElementById(id);
  if (!el) return null;

  const value = el.value;

  if (asNumber) {
    const num = Number(value.replace(/\D/g, "")); // убираем все, кроме цифр
    return isNaN(num) ? null : num;
  }

  return value;
}
